// PurchaseRequestDetails.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

//Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../../Assets";

//redux
import { useDispatch } from "react-redux";
import { fetchIndividualPurchaseReq } from "../../../../Redux/Slices/requestManagementSlice";

const PurchaseRequestDetails = () => {
  const {id} = useParams()
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const [purchaseRequestData,setPurchaseRequestData] = useState()

   useEffect(()=>{
    dispatch(fetchIndividualPurchaseReq({
      data:{id},
      callBack:(value)=>{
        console.log(value.data)
        setPurchaseRequestData(value.data)
      }
    }))
   },[]) 
  return (
    <MainLayout pageName="Enquires">
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Enquires</p>
      </div>
      <div className="PurchaseRequestDetailsContainer">
        {/* Header */}
        <div className="PurchaseRequestDetailsHeader">
          <h2>Enquiry Details</h2>
          <p>PR: #{purchaseRequestData?.purchase_request_id}</p>
        </div>
        <hr style={{ backgroundColor: "#E6E6E6" }} />
        <p className="purchaseRequestSubheading">Product Details</p>
        {/* Product Details */}
        <div className="ProductDetails">
          {/* {purchaseRequestData.map((item) => ( */}
          <div className="ProductCard">
            <div className="ProductInfo">
              <h3>{purchaseRequestData?.product_name || "-"}</h3>
              {/* <p className="ProductCode">{purchaseRequestData?.productCode || "-"}</p> */}
              <p>
                Quantity Requested &nbsp;&nbsp;:{" "}
                {purchaseRequestData?.quantity || "-"}
              </p>
              <p>
                Message &nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                : {purchaseRequestData?.message || "-"}
              </p>
            </div>
          </div>
          <div className="ProductCard">
            <div className="ProductInfo">
              <h3>Additional Details</h3>
              {/* <p className="ProductCode">{purchaseRequestData?.productCode || "-"}</p> */}
              <p>
                Username &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:{" "}
                {purchaseRequestData?.user_name || "-"}
              </p>
              <p>
                Mobile &nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                : {purchaseRequestData?.country_code }&nbsp;{purchaseRequestData?.mobile || "-"}
              </p>
              <p>
                Email &nbsp;
               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                : {purchaseRequestData?.email || "-"}
              </p>
              <p>
                Company Name &nbsp;
               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                : {purchaseRequestData?.company_name || "-"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default PurchaseRequestDetails;
